import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { CallApiService } from 'src/api/ai/call'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createCall, createCallFailure, createCallSuccess } from '../agents'
import { loadCalls, loadCallsFailure, loadCallsSuccess } from './call.actions'

@Injectable()
export class CallEffects {
  private actions$ = inject(Actions)
  private CallApi = inject(CallApiService)
  private toaster = inject(ToasterService)


  loadCalls$ = createEffect(() => this.actions$.pipe(
    ofType(loadCalls),
    switchMap((action) =>
      from(this.CallApi.queryCalls({ agent_id: action.agent_id, fields: action.fields })).pipe(
        map(calls => loadCallsSuccess({ calls })),
        catchAndLog(this.toaster, 'Unable to fetch calls', loadCallsFailure)))))

  createCall$ = createEffect(() => this.actions$.pipe(
    ofType(createCall),
    switchMap(({ call_id, retry_call_id, agent_id, account, user_id, trader_id, phone, variableValues, transferValues, vapiCall }) =>
      from(this.CallApi.createCall({ call_id, retry_call_id, agent_id, account, user_id, trader_id, phone, variableValues, transferValues, vapiCall })).pipe(
        map(({ data: call }) => createCallSuccess({ call })),
        catchAndLog(this.toaster, 'Unable to create call', createCallFailure)))))
} 